// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__FIRin","fileBtn":"File_fileBtn__3ufTp","closeBtn":"File_closeBtn__2wy-j","fileSelected":"File_fileSelected__Sy_rE","disabled":"File_disabled__3qe3w"};